import React from "react";
import "antd/dist/antd.css";
import { BrowserRouter as Router } from "react-router-dom";
import LandingRoutes from "./routes/landingRoutes";

function App() {
  return (
    <Router>
      <LandingRoutes />
    </Router>
  );
}

export default App;
